import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AnimatedLetter from "../../AnimatedLetters/index";
import "./index.scss";

import { AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import { getPost, updateViews } from "../../../feature/posts/postSlice";
import Loader from "../../loader/Loader";

const Blog = () => {
  const strArray = "Blogs Post".split("");
  const [letterClass, setLetterClass] = useState("text-animate");
  const dispatch = useDispatch();
  const { isLoding, posts } = useSelector((state) => state.posts);

  const handleViews = (id) => {
    const viewsPost =
      posts.AllPosts && posts.AllPosts.filter((post) => post._id === id);
    const viewsId = viewsPost[0]._id;
    const views = viewsPost[0].views + 1;
    dispatch(updateViews({ viewsId, views }));
  };

  useEffect(() => {
    dispatch(getPost());

    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, [dispatch]);

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h1 className="header-h1">
          <AnimatedLetter
            strArray={strArray}
            idx={15}
            letterClass={letterClass}
          />
        </h1>
        <p className="sub-text">Blog point</p>
      </div>
      {isLoding ? (
        <Loader />
      ) : (
        <div className="blogs">
          {posts.AllPosts &&
            posts.AllPosts.map((blog) => {
              const { _id, title, createdOn, views, image } = blog;

              return (
                <article key={_id}>
                  <img src={`${image}`} alt="name" />
                  <Link
                    to={`/blog/${_id}`}
                    onClick={() => {
                      handleViews(_id);
                    }}
                    state={blog}
                  >
                    <h2 className="blog-title">{title}</h2>
                  </Link>
                  <div className="blog-info">
                    <p className="date">
                      {new Date(createdOn).toLocaleDateString()}
                    </p>
                    <p className="views">
                      <span>
                        <AiOutlineEye />
                      </span>{" "}
                      {views}
                    </p>
                  </div>
                </article>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default Blog;
